import Adapter from "./adapter";
import log from "../logger";
import storage from "../utilities/storage";

let _id = 0;

/**
 * The IndexedDbAdapter connects to the browser's local indexed DB. This allows for storing data locally or for offline
 * usage.
 */
class IndexedDbAdapter extends Adapter {
    constructor(options) {
        super(options);
    }

    connect(options) {
        if (!options) {
            throw new Error("options must be passed in with at least a root or query parameter");
        }
        if (!options.root || !options.id) {
            throw new Error("IndexedDbAdapter requires a root and id");
        }

        this.disconnect();
        this.connected = true;
        this.updateType = Adapter.TYPE.initialize;

        this.storage = storage.use(options.root);
        this.id = options.id;

        this.onRemoteChange = options.onRemoteChange;
        this.onRemoteError = options.onRemoteError || function(err) {
            log.error(err);
        };

        this._refId = `${options.root}/${this.id}`;

        this.refresh();
        log.info(log.ADAPTER)(`connected to indexDB at ${this._refId}`);

        return this.id;
    }

    /**
     * Special method to reload from the indexDB
     */
    refresh() {
        this.storage.get(this.id).then(data => {
            if (!data) {
                const error = new Error(`IndexDB reference does not exist: ${this._refId}`);
                error.statusCode = 404;
                throw error;
            } else {
                this.onRemoteChange(this.updateType, data);
                this.updateType = Adapter.TYPE.replace;
            }
        }).catch(err => {
            this.onRemoteError(err);
            this.updateType = Adapter.TYPE.replace;
        });
    }

    isConnected() {
        return this.connected;
    }

    disconnect() {
        this.connected = false;
    }

    update(type, newData, currentData) {
        log.warn("Trying to update a storage adapter model.");
        return Promise.resolve();
    }

    createUid(root) {
        log.warn("Trying to create a uid for a storage adapter model.");
        return _id++;
    }
}

export default IndexedDbAdapter;
